(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["perleni-cart-bonuses"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perleni-cart-perks')) {
  customElements.define('perleni-cart-perks', class extends HTMLElement {
    connectedCallback() {
      if (this.positioned) return;
      const root = this.closest('#main-cart-footer, #CartDrawer');
      const checkout = root?.querySelector('.cart__ctas');
      if (!checkout) return;
      this.positioned = true;
      root.querySelectorAll('perleni-cart-perks').forEach((previous) => {
        if (previous !== this) previous.remove();
      });
      checkout.insertAdjacentElement('afterend', this);
    }
  });
}


function perleniSampleSetPlan(cart, sampleIds, setId) {
  if (cart.items.some((item) => String(item.variant_id) === String(setId))) return null;
  const updates = {};
  let selected = 0;
  for (const id of sampleIds) {
    const item = cart.items.find((line) => String(line.variant_id) === String(id) && line.quantity > 0 && !line.selling_plan_allocation && !line.parent_relationship);
    if (!item) continue;
    updates[item.key] = item.quantity - 1;
    selected += 1;
  }
  if (!selected) return null;
  updates[String(setId)] = 1;
  return { updates, selected };
}

if (!customElements.get('perleni-sample-set')) {
  customElements.define('perleni-sample-set', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('button').addEventListener('click', () => this.upgrade());
    }

    async request(path, body) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error(this.dataset.error);
      return response.json();
    }

    async upgrade() {
      if (window.perleniSampleSetBusy) return;
      window.perleniSampleSetBusy = true;
      const button = this.querySelector('button');
      const originalLabel = button.textContent;
      const error = this.querySelector('[role="alert"]');
      const controls = [...document.querySelectorAll('[name="checkout"]')].map((node) => [node, node.disabled]);
      const itemAreas = [...document.querySelectorAll('cart-items,cart-drawer-items')].map((node) => [node, node.inert]);
      button.disabled = true;
      button.textContent = this.dataset.busy;
      error.hidden = true;
      this.setAttribute('aria-busy', 'true');
      controls.forEach(([node]) => { node.disabled = true; });
      itemAreas.forEach(([node]) => { node.inert = true; });
      let changed = false;
      try {
        const cart = await this.request('cart.js');
        const plan = perleniSampleSetPlan(cart, this.dataset.samples.split(','), this.dataset.variant);
        if (!plan) {
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
          return;
        }
        const product = await this.request('products/' + encodeURIComponent(this.dataset.handle) + '.js');
        const variant = product.variants.find((item) => String(item.id) === this.dataset.variant);
        if (!variant?.available || variant.price !== Number(this.dataset.price)) throw new Error(this.dataset.error);
        const mappings = [];
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        if (items) mappings.push({ id: items.dataset.id, target: '#main-cart-items .js-contents', source: '.js-contents' });
        if (footer) mappings.push({ id: footer.dataset.id, target: '#main-cart-footer .js-contents', source: '.js-contents' });
        if (document.getElementById('CartDrawer')) mappings.push({ id: 'cart-drawer', target: '#CartDrawer', source: '#CartDrawer' });
        mappings.push({ id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' });
        const result = await this.request('cart/update.js', { updates: plan.updates, sections: [...new Set(mappings.map((item) => item.id))], sections_url: window.location.pathname });
        changed = true;
        if (!result.items.some((item) => String(item.variant_id) === this.dataset.variant && item.quantity === 1)) throw new Error(this.dataset.error);
        const replacements = mappings.map((mapping) => {
          const target = document.querySelector(mapping.target);
          const section = result.sections?.[mapping.id];
          const source = section && new DOMParser().parseFromString(section, 'text/html').querySelector(mapping.source);
          if (!target || !source) throw new Error(this.dataset.error);
          return { target, source };
        });
        const success = this.dataset.success;
        replacements.forEach(({ target, source }) => { target.innerHTML = source.innerHTML; });
        const region = document.getElementById('cart-live-region-text');
        if (region) { region.textContent = success; region.setAttribute('aria-hidden', 'false'); }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
        document.querySelector('#checkout,#CartDrawer-Checkout')?.focus();
      } catch (failure) {
        if (changed) {
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } else {
          error.textContent = this.dataset.error;
          error.hidden = false;
        }
      } finally {
        controls.forEach(([node, disabled]) => { node.disabled = disabled; });
        itemAreas.forEach(([node, inert]) => { node.inert = inert; });
        button.disabled = false;
        button.textContent = originalLabel;
        this.removeAttribute('aria-busy');
        window.perleniSampleSetBusy = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["perleni-scent-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perleni-scent-filter')) {
    customElements.define('perleni-scent-filter', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const initialize = () => {
          this.grid = document.getElementById(this.dataset.gridId);
          if (!this.grid) return;
          this.items = Array.from(this.grid.children).filter((item) => item.matches('li'));
          if (!this.items.some((item) => item.querySelector('[data-perleni-scent-families]'))) return;
          this.buttons = Array.from(this.querySelectorAll('[data-scent-family]'));
          this.description = this.querySelector('[data-scent-description]');
          this.count = this.querySelector('[data-scent-count]');
          const scope = this.closest('.shopify-section');
          const selected = scope?.dataset.perleniScentFamily || 'all';
          this.applyFilter(selected);
          this.hidden = false;
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-scent-family]');
            if (!button || !this.contains(button)) return;
            this.applyFilter(button.dataset.scentFamily);
            if (scope) scope.dataset.perleniScentFamily = button.dataset.scentFamily;
          }, { signal });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
        } else {
          initialize();
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      applyFilter(family) {
        const selectedButton = this.buttons.find((button) => button.dataset.scentFamily === family) || this.buttons[0];
        if (!selectedButton) return;
        family = selectedButton.dataset.scentFamily;
        let count = 0;
        let soonCount = 0;
        this.items.forEach((item) => {
          const families = item.querySelector('[data-perleni-scent-families]')?.dataset.perleniScentFamilies.split(' ') || [];
          const visible = family === 'all' || families.includes(family);
          item.hidden = !visible;
          item.toggleAttribute('data-perleni-filter-hidden', !visible);
          if (visible && item.querySelector('[data-perleni-available="true"]')) count += 1;
          if (visible && item.querySelector('[data-perleni-available="false"]')) soonCount += 1;
        });
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === selectedButton)));
        this.description.textContent = selectedButton.dataset.description;
        const countParts = [];
        if (count > 0 || soonCount === 0) countParts.push(this.dataset.countLabel.replace('[count]', String(count)));
        if (soonCount > 0) countParts.push(this.dataset.soonCountLabel.replace('[count]', String(soonCount)));
        this.count.textContent = countParts.join(' · ');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["perleni-scent-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('perleni-scent-picker')) {
    customElements.define('perleni-scent-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.querySelector('select')?.addEventListener('change', (event) => {
          const url = new URL(event.target.value, window.location.origin);
          if (url.origin === window.location.origin) window.location.assign(url.href);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
